<nb-alert accent="danger" *ngIf="error && errorMessage">{{ errorMessage }}</nb-alert>
